import { editedTitle } from 'lib/community/discussions'

/**
 * "· edited" after a post's age, on the thread header and on list cards, when DealHunt sends
 * `edited_at`. Public data, server-rendered: the tooltip is a UTC date (`editedTitle`), so the
 * shared-cached HTML and every browser agree.
 */
const EditedMarker: React.VFC<{ at: string | null | undefined; className?: string }> = ({
  at,
  className,
}) => {
  if (!at) {
    return null
  }
  return (
    <time dateTime={at} title={editedTitle(at) ?? undefined} className={className}>
      {'· edited'}
    </time>
  )
}

export default EditedMarker
